import { useQuery, keepPreviousData } from '@tanstack/react-query';
import {
  getEntrepreneur,
  getEntrepreneurTimeline,
  searchEntrepreneurs,
  type SearchFilters,
  type TimelineFilters,
} from '@/api/entrepreneurs';

/**
 * TanStack Query wrappers for the entrepreneurs endpoints. Centralised
 * here so cache keys stay consistent across components — every call site
 * uses the same key shape, which makes invalidation trivial when an
 * import or a manual declaration mutates a row.
 */

export function useEntrepreneursSearch(filters: SearchFilters) {
  return useQuery({
    queryKey: ['entrepreneurs', 'search', filters],
    queryFn: () => searchEntrepreneurs(filters),
    placeholderData: keepPreviousData,
  });
}

export function useEntrepreneur(phone: string | undefined) {
  return useQuery({
    queryKey: ['entrepreneurs', 'get', phone],
    queryFn: () => getEntrepreneur(phone as string),
    enabled: !!phone,
  });
}

export function useEntrepreneurTimeline(
  phone: string | undefined,
  filters: TimelineFilters,
) {
  return useQuery({
    queryKey: ['entrepreneurs', 'timeline', phone, filters],
    queryFn: () => getEntrepreneurTimeline(phone as string, filters),
    enabled: !!phone,
    placeholderData: keepPreviousData,
  });
}
